var React = require('react');

function MapPinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.41876 0.416748C3.16166 0.416748 0.52124 3.05717 0.52124 6.31427C0.52124 7.76835 1.04989 9.09723 1.92231 10.1255L6.41876 15.421L10.915 10.1254C11.7875 9.09723 12.3161 7.76818 12.3161 6.3141C12.3163 3.05717 9.67586 0.416748 6.41876 0.416748ZM6.41876 8.53657C5.07921 8.53657 3.9934 7.45076 3.9934 6.11121C3.9934 4.77166 5.07921 3.68585 6.41876 3.68585C7.75831 3.68585 8.84412 4.77166 8.84412 6.11121C8.84412 7.45076 7.75831 8.53657 6.41876 8.53657Z","fill":"currentColor"}));
}

MapPinInline.defaultProps = {"fill":"none"};

module.exports = MapPinInline;

MapPinInline.default = MapPinInline;
